import type { JSX } from "react";
import { useEffect } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
}

const HERO = {
  name: "Adam Kotlorz",
  location: "Software Engineer · remote",
};
const SKILLS: { group: string; items: { label: string }[] }[] = [
  {
    group: "Languages",
    items: [{ label: "TypeScript" }, { label: "Python" }, { label: "Go" }],
  },
  {
    group: "Frontend",
    items: [
      { label: "React" },
      { label: "Next.js" },
      { label: "Three.js" },
      { label: "GSAP" },
    ],
  },
  {
    group: "Backend",
    items: [
      { label: "Node.js" },
      { label: "PostgreSQL" },
      { label: "MongoDB" },
    ],
  },
  {
    group: "AI / ML",
    items: [{ label: "PyTorch" }, { label: "training pipelines" }],
  },
  { group: "Mobile", items: [{ label: "React Native" }] },
  {
    group: "Process",
    items: [{ label: "Scrum" }, { label: "Radical Candor" }],
  },
];
const SOCIALS = [
  { label: "GitHub", href: "https://github.com/adkotlorz" },
  { label: "Email", href: "mailto:ad.kotlorz@gmail.com" },
];

const buildResume = (): string => {
  const lines = [
    `name: ${HERO.name}`,
    `location: ${HERO.location}`,
    "",
    "stack:",
    ...SKILLS.flatMap((g) => [
      `  ${g.group}:`,
      ...g.items.map((it) => `    - ${it.label}`),
    ]),
    "",
    "contact:",
    ...SOCIALS.map((s) => `  ${s.label}: ${s.href}`),
    "",
    "commands: clear · exit · esc",
  ];
  return lines.join("\n");
};

export const WhoamiModal = ({ open, onClose }: Props): JSX.Element | null => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="whoami"
      className="fixed inset-0 z-50 bg-bg0/95 p-8 font-mono text-sm text-phosphor"
    >
      <pre className="whitespace-pre-wrap">{buildResume()}</pre>
      <button
        type="button"
        onClick={onClose}
        className="absolute right-6 top-6 font-mono text-xs uppercase text-ink2 hover:text-phosphor"
      >
        [esc] exit
      </button>
    </div>
  );
};
